import {Fragment, useContext} from "react";
import Translate from "../Translate";
import {MobileContext} from "../../context/MobileContext.jsx";
import {SpeedDial} from "primereact/speeddial";
import NsButtonNavigazione from "../buttons/NsButtonNavigazione.jsx";

const Card = ({children, title, subtitle, icon, bottoniSx = [], bottoniDx = [], onlyShowChildren = false}) => {

    const {isMobile} = useContext(MobileContext);

    function getBottoniSxDesktop() {
        return bottoniSx.filter(b => !!b).map((b, idx) => (
            <NsButtonNavigazione
                key={idx}
                onClick={b.command}
                label={b.label}
                icona={b.icon}
            />
        ));
    }

    function getBottoniDxDesktop() {
        return bottoniDx.filter(b => !!b).map((b, idx) => (
            <NsButtonNavigazione
                key={idx}
                onClick={b.command}
                label={b.label}
                icona={b.icon}
            />
        ));
    }

    return (
        isMobile ?
            <Fragment>
                <div className="ns-card">
                    {
                        !onlyShowChildren &&
                        <div className={"card-title p-1"}>
                            <div className={"ms-4 text-start ns-card-title-container"}>
                                <h5 className="">
                                    <i className={icon}/>&nbsp;<Translate>{title}</Translate>
                                </h5>
                                {
                                    subtitle && subtitle !== '' &&
                                    <h6 className="card-subtitle mb-2 ns_text-muted text-center">
                                        <Translate>{subtitle}</Translate>
                                    </h6>
                                }
                            </div>
                            <div className={"ns-btn-mobile-card"}>
                                {
                                    bottoniDx
                                        .filter(b => b)
                                        .concat(bottoniSx.filter(b => b)).length > 0 &&
                                    <SpeedDial
                                        model={bottoniDx
                                            .filter(b => b)
                                            .concat(bottoniSx.filter(b => b))}
                                        direction="down"
                                        icon="pi pi-cog"
                                        style={{top: 2}}
                                        pt={{
                                            // workaround per il fatto che le opzioni dello speeddial rimangono disegnate sulla pagina anche se nascoste
                                            // in questo modo coprono gli elementi sottostanti che non sono cliccabili
                                            // se il bottone non è espanso TUTTO l'elemento ha altezza 0px in modo da non bloccare gli elementi sottostanti
                                            // il bottone ha un overflow in modo da essere disegnato correttametne
                                            root: ({state}) => {
                                                if (!state.visible) {
                                                    return {style: {maxHeight: '0px'}};
                                                }
                                                return {};
                                            },
                                            button: () => ({root: {style: {overflow: 'visible'}}})
                                        }}
                                        />
                                }
                            </div>
                        </div>
                    }
                </div>
                <div className={"ns-card-body p-3"}>
                    {children}
                </div>
            </Fragment>
            :
            <Fragment>
                <div className="ns-card">
                    {
                        !onlyShowChildren &&
                        <div className={"row card-title p-1"}>
                            <div className={"col-md-3 col-2 ps-4 text-start"}>
                                {
                                    getBottoniSxDesktop()
                                }
                            </div>
                            <div className={"col-md-6 col-8 text-center ns-card-title-container"}>
                                <h5 className="">
                                    <i className={icon}/>&nbsp;<Translate>{title}</Translate>
                                </h5>
                                {
                                    subtitle && subtitle !== '' &&
                                    <h6 className="card-subtitle mb-2 ns_text-muted text-center">
                                        <Translate>{subtitle}</Translate>
                                    </h6>
                                }
                            </div>
                            <div className={"col-md-3 col-2 text-end pe-4"}>
                                {
                                    getBottoniDxDesktop()
                                }
                            </div>
                        </div>
                    }
                </div>
                <div className={"ns-card-body p-3"}>
                    {children}
                </div>
            </Fragment>
    )
}

export default Card;